// Subscription Store

const state = {
  pending: false,
  billing_data: {},
}

const getters = {}

const actions = {
  getSubscriptionData({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.billing_items
      .getSubscriptionItem('subscriptions.mine')
      .then(({ data }) => {
        commit('SET_SUBSCRIPTION_DATA', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  removeSubscription({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.billing_items
      .deleteSubscriptionItem(`subscriptions.${id}`)
        .then(_ => {
          commit('DELETE_SUBSCRIPTION_DATA')
          commit('SET_PENDING')
          resolve()
        })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_SUBSCRIPTION_DATA(state, data) {
    state.billing_data = data
  },
  DELETE_SUBSCRIPTION_DATA() {
    return true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
